import React from 'react'
import './PropertyDataCollectorTermsAndConditions.scss'

const PropertyDataCollectorTermsAndConditions = () => {
  return (
    <div className="pdc-terms-modal-content">
      <section className="pdc-terms-intro">
        <h2 className="pdc-terms-title">Reggora Software Platform Terms of Use and Appraisal Services Agreement</h2>
        <p>Welcome to the Reggora software platform and www.reggora.com website and associated applications.</p>
        <p>
          The Reggora software platform and website, including the materials and applications accessed on the website,
          are referred to as the Platform in this Agreement. This document is a contract (referred to as the Agreement)
          between you, on your own behalf and on behalf of any company or firm with which you are affiliated
          (collectively referred to as You or Your) and Reggora, Inc. (Reggora). It governs Your use of the Platform as
          a property data collector.
        </p>
        <p>
          This Agreement also governs, if applicable, any relationship between You and Reggora&apos;s subsidiary,
          Appraisal Marketplace, LLC, in its capacity as an appraisal management company in specific states or
          jurisdictions where Appraisal Marketplace, LLC Reggora offers appraisal management services. In such states
          and jurisdictions, Reggora or Appraisal Marketplace, LLC may invite you to join its property data collector
          panel, and the Property Data Collector Services Agreement section of this Agreement will then apply as
          provided for in that section.
        </p>
        <p>You and Reggora/Appraisal Marketplace, LLC are collectively referred to below as the Parties.</p>
        <p>Accordingly, the Parties agree as follows:</p>
      </section>

      <section className="pdc-terms-section">
        <h3 className="pdc-terms-section-title">Platform Terms of Use</h3>
        <p>
          The terms and conditions in paragraphs 1 through 22 below, as well as the General Terms and Conditions, apply
          to the Platform.
        </p>

        <ol className="pdc-terms-numbered-list">
          <li>
            <span className="pdc-terms-list-item-title">Purpose of the Platform.</span> The purpose of the Platform is
            to provide a two-sided software system used by lender-clients and other purchasers of property data
            collection services to order and property data collection reports from You and other property data
            collectors in compliance with applicable laws, regulations and guidelines.
            <p>
              Your provision of information during registration for the Platform is to provide information that will be
              used by lender-clients or other purchasers of Your services to consider engaging You.
            </p>
            <p>
              In providing the Platform, Reggora is not acting or holding itself out as an appraisal management company
              or providing appraisal management services.
            </p>
            <p>
              While Reggora may offer separate appraisal management services in some states or jurisdictions under
              it&apos;s subsidiary, Appraisal Marketplace, LLC, it does not provide, or offer, appraisal management
              services in any state or jurisdiction in which it is not registered as an appraisal management company.
            </p>
            <p>
              Any membership by You on an data collector panel maintained by Reggora or provision of data collection
              services by You in connection with any appraisal management services by Appraisal Marketplace, LLC Reggora
              is subject to the Data Collector Services Agreement section of this Agreement.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Access to the Platform.</span> Reggora hereby grants You, and
            You hereby accept, a limited, revocable, non-exclusive right to access the Platform solely for purposes
            related to Your provision of appraisal services to lender-clients or other parties utilizing the Platform to
            order and receive Your appraisal services.
            <p>Any other use of the Platform is prohibited.</p>
            <p>
              You agree to take commercially reasonable efforts to prevent unauthorized access to the Platform and
              notify Reggora promptly of any such unauthorized access.
            </p>
            <p>
              You agree that You will not use the Platform in violation of applicable laws or regulations or send
              infringing, threatening or otherwise unlawful or tortious material through the Platform.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">No Warranty Regarding Continuous Access.</span> Reggora does not
            warrant or guarantee continuous or uninterrupted access to the Platform.
            <p>
              Software, applications, services and features may be added to or deleted from the Platform at
              Reggora&apos;s sole discretion and without notice, and Reggora reserves the right to modify or cease
              operation of the Platform or any portion of the Platform.
            </p>
            <p>
              Reggora shall not be liable to You or any other party for modifications to or cessation of operation of
              the Platform or any portion of the Platform.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Ownership of the Platform.</span>
            <p>
              As between You and Reggora, Reggora and/or its licensors own all right, title and interest to the
              Platform, including any and all copyrights, trademarks, trade secrets, patents and other proprietary
              rights (collectively Intellectual Property Rights).
            </p>
            <p>
              Except for the limited rights expressly granted to You under this Agreement, Reggora reserves all rights,
              title and interest in and to the Platform, including all related Intellectual Property Rights.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Your Use of the Platform.</span> In connection with Your
            activities on the Platform, You shall (i) provide Your services and use the Platform in accordance with all
            applicable laws, regulations and guidelines, (ii) make no false or misleading representations to any party
            with regard to the Platform or any product or service offered by You, and (iii) not participate or engage in
            any illegal, deceptive, misleading, unethical or improper practice or infringe any third party&apos;s
            copyright, patent, trademark, trade secret or other proprietary rights or privacy.
          </li>

          <li>
            <span className="pdc-terms-list-item-title">
              Obligations with Respect to Your Property Data Collection Appraisal Services.
            </span>
            <p>
              You warrant and agree, for the express benefit of lender-clients or other parties using the Platform to
              obtain Your services, that:
            </p>
            <p>
              The information that You have provided in the Platform about Yourself and any company or firm with which
              You are affiliated is true and complete and that You will always provide true and complete information in
              the Platform;
            </p>
            <p>
              Any property data collection services that You deliver through the Platform will comply with all
              applicable professional standards, laws, regulations and guidelines, and that You will deliver Your
              property data collection services in accordance with all applicable independence and standard
              requirements, including those established by Reggora, inc.
            </p>
            <p>
              You will not accept any assignment in the Platform for which You are not legally qualified as a property
              data collector or which You determine You are not competent to perform, whether based on experience,
              knowledge or available data resources.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Payment for Your Property Data Collection Services.</span>
            <p>
              Reggora, Inc. through the Platform is the party responsible for paying You when Reggora itself has engaged
              Your services for appraisal assignments through its subsidiary, Appraisal Marketplace, LLC pursuant to the
              Services Agreement section below. Reggora, Inc. is not responsible for services requested by any
              unauthorized parties or for unauthorized services (i.e. data collection services completed when an order
              is in HOLD status, or after service is marked as complete and accepted in the Reggora platform without
              permission granted by Reggora, Inc. or Appraisal Marketplace, LLC).
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">LIMITED WARRANTY.</span> THE PLATFORM IS PROVIDED
            &quot;AS-IS&quot; AND, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, REGGORA DISCLAIMS ALL OTHER
            REPRESENTATIONS AND WARRANTIES, EXPRESS, IMPLIED OR STATUTORY, REGARDING THE PLATFORM, INCLUDING WITHOUT
            LIMITATION ITS FITNESS FOR A PARTICULAR PURPOSE, ITS QUALITY, ITS MERCHANTABILITY, ITS PERFORMANCE, OR THE
            RESULTS OBTAINED BY USING THE PLATFORM.
          </li>

          <li>
            <span className="pdc-terms-list-item-title">LIMITATION OF LIABILITY.</span>
            <p>
              YOU ACKNOWLEDGE THAT YOU HAVE NOT PAID ANY FEE TO ACCESS THE PLATFORM. ACCORDINGLY, TO THE MAXIMUM EXTENT
              PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL REGGORA BE LIABLE TO YOU FOR ANY COMPENSATORY,
              CONSEQUENTIAL, INCIDENTAL, DIRECT, INDIRECT, SPECIAL OR PUNITIVE DAMAGES WHATSOEVER (INCLUDING, WITHOUT
              LIMITATION, ANY LOST PROFITS, LOST SAVINGS, BUSINESS PROFITS, BUSINESS INTERRUPTION OR ANY OTHER LOSS)
              (COLLECTIVELY &quot;LOSSES&quot;) ARISING OUT OF YOUR USE OF THE PLATFORM, EVEN IF REGGORA HAS BEEN
              ADVISED OF THE POSSIBILITY OF SUCH LOSSES. IN ANY EVENT, REGGORAMAXIMUM MONETARY LIABILITY FOR ANY LOSS
              SHALL BE LIMITED TO $100.00. IN ANY JURISDICTION WHERE THE EXCLUSION OR LIMITATIONS ON THE TYPE AND/OR
              AMOUNT OF LOSSES DO NOT APPLY OR ARE RESTRICTED, REGGORA&apos;S LIABILITY FOR LOSSES SHALL BE LIMITED TO
              THE MAXIMUM EXTENT PERMITTED BY SUCH JURISDICTION&apos;S LAWS.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Responsibility for Negligence and Misconduct.</span>
            <p>
              Without limiting Your other legal duties and responsibilities, You agree to indemnify and hold harmless
              Reggora, and its officers, directors, employees, representatives and agents, from and against any and all
              claims, causes of action, damages, losses, or liabilities resulting from or arising out of third party
              claims against Reggora, and/or its officers, directors, employees, representatives or agents, relating to
              any alleged or actual negligence, errors, omissions, or criminal or intentional misconduct on Your part.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Amendments.</span> Reggora may amend these Platform Terms of Use
            at any time by notifying You when You log onto the Platform, by emailing you or by posting the amended terms
            on the Platform website.
            <p>All amended terms shall automatically be effective when You are so notified in any such manner.</p>
            <p>This Agreement may not be otherwise amended except in a writing signed by You and Reggora.</p>
          </li>
        </ol>
      </section>

      <section className="pdc-terms-section">
        <h3 className="pdc-terms-section-title">Services Agreement</h3>
        <p>
          Reggora, Inc, or, Appraisal Marketplace, LLC may offer appraisal property data collection services to
          lender-clients or other parties and may seek to order property data collection services from You.
        </p>
        <p>
          Paragraphs 12 through 24 below, as well as the General Terms and Conditions, apply to any property data
          collections services for which you are contracted by Reggora or Appraisal Marketplace, LLC as an appraisal
          management company and to any relationship between You and Reggora or Appraisal Marketplace, LLC in its
          capacity as an appraisal management company.
        </p>
        <p>This Appraisal Services Agreement section shall not otherwise apply in any manner.</p>

        <ol className="pdc-terms-numbered-list" start="12">
          <li>
            <span className="pdc-terms-list-item-title">Your Services.</span>
            <p>
              As may be requested from time-to-time by Appraisal Marketplace, LLC, You will provide professional
              property data collection services in accordance with the terms and conditions of this Agreement for
              assignments accepted by You in separate engagement letters or orders or in other assignment confirmations
              (via electronic ordering portals or by other means) which may state the property location, and due date(an
              Order).
            </p>
            <p>
              Your services, reports and work product shall meet the specifications in each Order in addition to the
              requirements in this Agreement.
            </p>
            <p>
              You shall make every effort to complete and deliver the property data collection service before the due
              date in an Order.
            </p>
            <p>
              Any anticipated delays in completing an assignment before the agreed due date should be communicated
              immediately to Appraisal Marketplace, LLC, who shall have the right in its discretion to then reassign the
              assignment to another firm or data collector.
            </p>
            <p>
              Appraisal Marketplace, LLC may develop service level performance standards including delivery of services
              and property data collection completeness and quality, as the basis for establishing eligibility for
              future assignments. You acknowledge and agree that this Agreement is not a guarantee of future assignments
              and that Reggora and Appraisal Marketplace, LLC makes no promise or guarantee as to any minimum number of
              assignments or minimum level of revenue.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Data Collection Fees.</span> Appraisal Marketplace, LLC agrees
            to pay the fee stated in an Order for an assignment within 30 calendar days after Reggora receipt of a
            completed report fulfilling the requirements of this Agreement and the terms of the applicable Order, or
            within any shorter applicable period required by law or regulation in the state or jurisdiction of the
            assignment.
            <p>
              You agree that You will not charge or invoice any party other than Appraisal Marketplace, LLC for services
              provided under this Agreement, unless requested to do so in the Order.
            </p>
            <p>
              You are solely responsible for Your own costs and expenses associated with completing services for Reggora
              or Appraisal Marketplace, LLC, including, without limitation, the costs and expenses of education,
              transportation, technology devices, software, data, insurance, taxes (federal, state or local), social
              security, disability insurance, unemployment insurance and/or worker&apos;s compensation.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Your Responsibilities and Representations.</span>
            <p>You agree and certify:</p>
            <p>
              You have not pled guilty or nolo contendere (No Contest) to any crime involving dishonesty, fraud, theft,
              public trust, breach of trust, or money laundering, or to any crime that would disqualify employment with
              an FDIC regulated institution or as a real estate licensed professional (real estate agent/broker or
              appraiser).;
            </p>
            <p>
              You have not been convicted of any crime involving dishonesty, fraud, theft, public trust, breach of
              trust, or money laundering, or any crime that would that would suspend employment with an FDIC regulated
              institution or licensure as a real estate licensed professional (real estate agent/broker or appraiser);
            </p>
            <p>
              You have not been involved in any civil or criminal legal proceedings involving dishonesty, fraud, theft,
              public trust, breach of trust, or money laundering, or any crime that would suspend or terminate
              employment with an FDIC regulated institution or licensure as a real estate licensed professional (real
              estate agent/broker or appraiser);
            </p>
            <p>
              You agree to report to Reggora and/or Appraisal Marketplace, LLC in writing any change to Your ability to
              acknowledge the statements in this section upon first discovery or knowledge of.
            </p>
            <p>
              Reggora Inc. or Appraisal Marketplace, LLC may require You to submit to background checks and other
              screenings, in accordance with applicable laws, and You agree to furnish information necessary for such
              checks or screenings.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Qualifications and Competency for Assignments.</span>
            <p>
              No property data collector will perform any property data collection appraisal assignment unless: (i) the
              data collector is deemed competent to perform data collection services through recognized training, and
              (ii) the data collector has no interest in the subject property or related transaction.
            </p>
            <p>
              You agree to notify Reggora or Appraisal Marketplace, LLC immediately in writing if it is determined that
              you are not qualified or competent to complete an assignment.
            </p>
            <p>
              You are aware that misrepresentation of qualifications or competency may violate applicable state law..
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Compliance with Standards and Laws.</span> Data Collection
            services performed by You under this Agreement will be performed in conformity with the Reggora Data
            Collection Standards and all laws and regulations pertaining to the applicable appraisal services.
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Performance Standards.</span>
            <p>
              All property data collection services are to be performed in a professional manner, and all interaction
              with parties related to the data collection process are to be maintained at a respectful and professional
              level of service, including the expectation of professional attire when meeting with parties to a
              transaction for which property data collection services are required.
            </p>
            <p>
              Reggora and Appraisal Marketplace, LLC may from time-to-time publish additional its own standards and
              performance requirements or set forth additional standards in an Order (collectively, the Performance
              Standards) which, without limitation, may advise data collectors of specific requirements of the client or
              intended user of the appraisal.
            </p>
            <p>
              You will comply with the Performance Standards. Performance standards include delivery of services and
              data collection reporting meeting completeness and quality standards and may be used as the basis for
              establishing eligibility for future assignments.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Confidentiality and Privacy.</span>
            <p>
              You will maintain the confidentiality and privacy of client and consumer information obtained by You or
              Your personnel in the course of completing services under this Agreement and of any nonpublic personal
              information about customers and consumers as those terms are defined in the Gramm-Leach-Bliley Act (GLBA)
              and/or in any applicable state privacy laws (collectively, all such information shall be referred to as
              Confidential Information in this paragraph).
            </p>
            <p>
              You agree that neither You nor any of Your personnel will use or disclose any Confidential Information
              other than as necessary to carry out the permitted purposes for which such information was disclosed to or
              obtained or as required by law or legal process.
            </p>
            <p>
              You agree to take all reasonable measures, including without limitation such measures as You take to
              safeguard Your own confidential information, to ensure the security and confidentiality of all
              Confidential Information, to protect against anticipated threats or hazards to the security or integrity
              of such Confidential Information and to protect against unauthorized access to or use of such Confidential
              Information.
            </p>
            <p>
              You shall promptly notify Reggora and all potentially affected parties in writing of each instance of (i)
              unauthorized access to or use of Confidential Information that could result in substantial harm or
              inconvenience to a customer or consumer or (ii) unauthorized disclosure, misuse, alteration, destruction
              or other compromise of Confidential Information.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Your Independent Contractor Status.</span>
            <p>
              You represent and agree that You solely shall be an independent contractor to Reggora or Appraisal
              Marketplace, LLC for all purposes of performing services under this Agreement and for any other services
              rendered to Reggora or Appraisal Marketplace, LLC.
            </p>
            <p>
              This Agreement is not an employment agreement, and neither You nor any of Your personnel is an employee of
              Reggora or Appraisal Marketplace, LLC for any purpose, including, but not limited to, application of the
              Federal Insurance Contribution Act, Social Security Act, Federal Unemployment Tax Act, Internal Revenue
              Code, state and federal income tax withholding requirements, workers compensation insurance, and
              third-party liability claims.
            </p>
            <p>
              This Agreement does not form or create a partnership or joint venture, and Reggora and Appraisal
              Marketplace, LLC shall not be liable for any obligations incurred by You unless specifically authorized in
              writing.
            </p>
            <p>
              You shall not act as an agent of Reggora or Appraisal Marketplace, LLC nor bind Reggora or Appraisal
              Marketplace, LLC in any manner.
            </p>
            <p>
              You shall not represent or communicate to any party that any of Your personnel are employees or agents of
              Reggora or Appraisal Marketplace, LLC.
            </p>
            <p>
              You are free to perform services for other clients or management companies and both Parties expect that
              You (and affiliated and approved property data collectors) will be performing such other services.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">
              Data Collection - Communications and Reconsideration Requests.
            </span>
            <p>
              You shall direct all communications concerning services performed under this Agreement to Reggora or
              Appraisal Marketplace, LLC , except for communications with the property owner or borrower regarding
              scheduling and inspection or other communications reasonably necessary to complete the assignment or as
              required by law. In the event that a client, borrower or other party requests a reconsideration of a
              property data collection service through Appraisal Marketplace, LLC, or otherwise challenges any factual
              data about the property and/or improvements, You agree to refer such inquiries to Appraisal Marketplace,
              LLC for resolution under Appraisal Marketplace, LLC then-in-place reconsideration procedures and to
              cooperate with and adhere to Appraisal Marketplace, LLC procedures for handling reconsiderations and other
              challenges. You acknowledge that the resolution of such reconsideration requests or other challenges may
              in some cases require further data collection or written response and agree that such analysis or response
              is part of the scope of work agreed to in connection with each assignment and will be provided at no
              additional charge.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Property Data Collector Panel Eligibility.</span>
            <p>
              In the event that Appraisal Marketplace, LLC determines that any property data collector is no longer
              eligible for assignments through Appraisal Marketplace, LLC appraisal management services, Appraisal
              Marketplace, LLC will provide notice in accordance with applicable state appraisal management company laws
              and regulations.
            </p>
            <p>
              If either You or any data collector disputes the determination, such party shall utilize the Dispute
              Resolution Process in paragraph 22.
            </p>
            <p>
              You acknowledge and agree that Appraisal Marketplace, LLC shall have sole discretion, exercised in
              accordance with any applicable state or federal laws or regulations, to determine eligibility for data
              collection assignments and inclusion of a property data collector on any Appraisal Marketplace, LLC data
              collector panel, except to the extent that such matter falls within the jurisdiction of an applicable
              state or federal licensing or regulatory agency. You acknowledge and agree that Appraisal Marketplace, LLC
              eligibility determinations, subject to any applicable state or federal laws or regulations, may be based,
              without limitation, on Appraisal Marketplace, LLC&apos;s evaluation of factors including an data
              collector&apos;s qualifications, background, professionalism, performance on past assignments, compliance
              with assignment requirements, timeliness and the demand for services in the relevant geographic area.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Informal Dispute Resolution Process.</span> Reggora and
            Appraisal Marketplace, LLC maintains a Dispute Resolution Process to handle and resolve contractor
            grievances and disputes informally and before resorting to legal action or arbitration.
            <p>
              This Dispute Resolution Process applies to any dispute by You or any data collector regarding eligibility
              on a Appraisal Marketplace, LLC data collector panel, nonpayment of fees, alleged violations of law or
              regulation, or any property data collector matter for which Appraisal Marketplace, LLC is required to have
              a dispute resolution process in place under state or federal law, except to the extent of any required
              dispute resolution procedures provided for under applicable appraisal management company laws or
              regulations (but only to the extent of such laws or regulations).
            </p>
            <p>In the event of such a grievance, the following Dispute Resolution Process will apply:</p>
            <p>
              Appraiser contact at Appraisal Marketplace, LLC for the Dispute Resolution Process will be:{' '}
              <a href="mailto:AMC_Compliance@reggora.com">AMC_Compliance@reggora.com</a>, ATTN: Coordinator. Appraisal
              Marketplace, LLC will give notice to You of changes regarding the contact for the Dispute Resolution
              Process.
            </p>
            <p>
              No later than 60 days after the determination or action of Reggora or Appraisal Marketplace, LLC that is
              being disputed, the aggrieved party shall provide a letter or other written explanation describing the
              nature of the dispute and explaining in detail why the determination or action of Reggora or Appraisal
              Marketplace, LLC was inappropriate or wrong, and also shall provide all documentation supporting the
              aggrieved party position.
            </p>
            <p>
              Upon receipt, the Coordinator will forward the materials received to a management level officer of Reggora
              or Appraisal Marketplace, LLC for review. The manager shall be above the level of the Reggora personnel
              who made the decision or determination in dispute.
            </p>
            <p>
              Within 30 days after receipt of the dispute, Reggora or Appraisal Marketplace, LLC will provide a written
              response and statement explaining the results of the review conducted by the manager and any actions that
              may be taken.
            </p>
            <p>
              Upon written request, the aggrieved party may obtain the records or other factual documentation considered
              by Reggora and Appraisal Marketplace, LLC as part of the review.
            </p>
            <p>
              The Dispute Resolution Process must be followed prior to the commencement of, and is a condition precedent
              to, any legal action or arbitration against Reggora or Appraisal Marketplace, LLC. The Dispute Resolution
              Process does not apply to appraisal reconsideration requests or other grievances by persons who are not
              parties to this Agreement.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Responsibility for Negligence and Misconduct.</span>
            <p>
              To the extent permitted by applicable state law (including state appraisal management company laws) and
              without limiting Your other legal duties and responsibilities, You agree to indemnify and hold harmless
              Reggora and Appraisal Marketplace, LLC, and its officers, directors, employees, representatives and
              agents, from and against any and all claims, causes of action, damages, losses, or liabilities resulting
              from or arising out of any negligence, errors, omissions, or criminal or intentional misconduct on Your
              part or on the part of any of Your personnel in performing property data collection services.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Tax Withholding.</span>
            <p>
              You acknowledge and agree that Reggora will not withhold any taxes, income or otherwise, from payments to
              You and that You will be required to file corporate, partnership, and/or individual tax returns and to pay
              taxes in accordance with applicable federal, state and local laws.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Third Party Beneficiaries and Use of Information.</span> In no
            case shall any borrower or any party who is not identified in an appraisal report as a client or intended
            user be construed as a third party beneficiary of this Agreement or of the services performed under this
            Agreement.
            <p>
              You agree and confirm that clients and intended users identified in appraisal reports have the right to
              use all work product, data and other information contained in appraisal reports and to permit third party
              vendors authorized by them, including Reggora and Appraisal Marketplace, LLC, to use such information for
              all proper legal purposes in accordance with applicable privacy and consumer protections.
            </p>
          </li>
        </ol>
      </section>

      <section className="pdc-terms-section">
        <h3 className="pdc-terms-section-title">General Terms and Conditions</h3>
        <p>
          The general terms and conditions below apply to all parts of this Agreement and are no less important than any
          other provisions.
        </p>

        <ol className="pdc-terms-numbered-list" start="25">
          <li>
            <span className="pdc-terms-list-item-title">Mutual Arbitration Provision.</span>
            <p>
              Following completion of the procedure described in paragraph 19 (if applicable), in the event of any
              dispute, claim or controversy between the Parties arising out of or relating to this Agreement or any
              breach thereof, including, without limitation, any claim that this Agreement or any of its parts is
              invalid, illegal or otherwise voidable or void, whether such dispute, claim or controversy sounds in
              contract, tort, equity or otherwise, and whether such dispute, claim or controversy relates to the
              meaning, interpretation, effect, validity, performance or enforcement of the Agreement, such dispute,
              claim or controversy shall be settled by and through an arbitration proceeding before a single arbitrator
              to be administered by the American Arbitration Association (or any like organization successor thereto) in
              Boston, Massachusetts, in accordance with the American Arbitration Association then-current Commercial
              Arbitration Rules. Each of the Parties to this Agreement hereby agrees and consents to such venue and
              waives any objection thereto.
            </p>
            <p>
              The arbitrability of any such dispute, claim or controversy shall likewise be determined in such
              arbitration.
            </p>
            <p>
              All issues relating to arbitrability or the enforcement of the agreement to arbitrate contained herein
              shall be governed by the Federal Arbitration Act (9 U.S.C. § 1 et seq.) and the federal common law of
              arbitration.
            </p>
            <p>
              In the event that an arbitrator or court determines that certain claims or issues are not subject to
              arbitration, only such claims and issues shall then not be subject to arbitration, and the remaining
              claims and issues shall be arbitrated.
            </p>
            <p>
              THE PARTIES TO THIS AGREEMENT WAIVE THEIR RIGHTS TO TRIAL BY COURT OR JURY AND TO THE ADJUDICATION OF ANY
              DISPUTES OR CLAIMS ON A CLASS OR COLLECTIVE BASIS.
            </p>
            <p>
              The arbitration procedure set forth in this paragraph shall not apply to injunctive relief relating to the
              Platform or information protected under paragraph 15.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Authority to Make Agreement.</span>
            <p>
              You represent and warrant to Reggora and Appraisal Marketplace, LLC that You have the authority, right and
              power to make this Agreement on behalf of any company or firm with which You are affiliated (whether as an
              employee, owner, member, partner or in any other capacity or manner of affiliation).
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Invalidity or Unenforceability.</span>
            <p>
              The invalidity or unenforceability of any term or provision of this Agreement shall not affect the
              validity or enforceability of the remainder of this Agreement.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Waiver.</span>
            <p>
              No change, waiver or discharge of this Agreement will be valid unless in writing and executed by the party
              against whom such change, waiver or discharge is sought to be enforced. A waiver by either of the Parties
              of any provision or breach shall not be a waiver of a preceding or subsequent breach of the same or any
              other provision nor shall it be a waiver of any other provisions or breach.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Governing Law.</span> This Agreement shall be construed and
            governed under the laws of Massachusetts without reference to its conflicts of laws principles.
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Notices.</span>
            <p>
              Any notices or correspondence under this Agreement from Reggora or Appraisal Marketplace, LLC to You may
              be provided by Reggora via email to You at the email address You provided in the Platform or by electronic
              messaging within the Platform, unless otherwise required by law or regulation to be delivered via other
              means.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Execution.</span>
            <p>
              Execution of this Agreement at different times and places by the Parties shall not affect the validity.
            </p>
            <p>
              A signature or agreement to be bound by this Agreement received by facsimile, by email or in digital form
              via a website shall be binding upon the Parties as an original.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Amendments and Modifications.</span>
            <p>
              This Agreement contains the entire agreement of the Parties with respect to the Platform and services
              described herein. No other agreement, statement, or promise made on or before the date this Agreement
              became effective will be binding on the Parties.
            </p>
            <p>
              Except as provided for in paragraph 11, this Agreement may only be modified by subsequent agreement of the
              Parties in a writing signed or duly accepted by electronic means by all the Parties.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Term and Termination.</span>
            <p>
              This Agreement shall be effective on the Effective Date and shall continue in force until terminated in
              writing by either of the Parties.
            </p>
            <p>
              This Agreement may be terminated by either of the Parties, with or without reason, immediately upon
              written notice. Despite termination of this Agreement, the following parts of this Agreement shall remain
              in full force and effect and be continuing obligations: 1, 3, 4, 5, 6, 7, 8, 9, 10, 13, 15, 16, 18, 19,
              21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31 and 32.
            </p>
          </li>

          <li>
            <span className="pdc-terms-list-item-title">Effective Date.</span>
            <p>
              This Agreement shall be effective and binding on, and the Effective Date of the Agreement shall be, the
              earlier of: (a) the date on which You sign the Agreement, or (b) the date on which You acknowledge
              acceptance of this Agreement electronically on a website utilized by Reggora and Appraisal Marketplace,
              LLC for that purpose.
            </p>
          </li>
        </ol>
      </section>
    </div>
  )
}

export default PropertyDataCollectorTermsAndConditions
